<template>
  <div class="gSwiperBox3">
    <swiper :options="swiperOption" :ref="name">
      <swiper-slide v-for="(item, index) in list" :key="'gSwiperCommon2-' + index">
        <img :src="item" v-if="item" />
        <img src="@assets/img/empty.png" v-else />
      </swiper-slide>
      <swiper-slide v-if="video && video.path">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { videoPlayer } from "vue-video-player";
export default {
  name: "gSwiperCommon2",
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    video: {
      type: Object,
      default: function() {
        return null;
      }
    }
  },
  data() {
    return {
      videoData: null,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      name: ""
    };
  },
  computed: {
    swiper() {
      return this.$refs[this.name].swiper;
    }, 
    playerOptions() {
      let res = {};
      if (this.video) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.video.path
            }
          ],
          poster: this.video.cover,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    }
  },
  created() {
    this.name = `mySwiper-${Math.random()}`;
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   this.swiper.slideTo(3, 1000, false);
  },
  components: {
    videoPlayer
  },
  methods: {
    onPlayerPlay(player) {},
    onPlayerPause(player) {},}
};
</script>

<style lang="scss">
.gSwiperBox3 {
  width: 100%;
  background-color: #ddd;
  .swiper-slide {
    img {
      width: 100%;
    }
  }
}
.gSwiperBox3 .swiper-container {
  font-size: 0;
}
.gSwiperBox3 .swiper-pagination {
  font-size: 0;
  display: flex;
  justify-content: center;
  padding-right: 18px;
  bottom: 22px;
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px; 
    background-color: #ddd;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background-color: #ed6e02;
    opacity: 1;
  }
}
</style>